import { render } from "./LogoNdldc.vue?vue&type=template&id=0b93903b&scoped=true&ts=true"
import script from "./LogoNdldc.vue?vue&type=script&lang=ts"
export * from "./LogoNdldc.vue?vue&type=script&lang=ts"

import "./LogoNdldc.vue?vue&type=style&index=0&id=0b93903b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b93903b"]])

export default __exports__